import { getComponentClasses } from '@99designs/common/utils/app';
import * as React from 'react';
import Icon from './Icon';

export interface Props {
    onClick: () => void;
    icon: string;
    variations: string[];
}

const IconButton: React.SFC<Props> = ({ icon, onClick, variations = [] }) => (
    <button
        type="button"
        onClick={onClick}
        className={getComponentClasses('icon-button', variations)}
    >
        <Icon icon={icon} />
    </button>
);

export default IconButton;
